import React from "react";

const NavOverlay = (props) => {
    const { closeOverlay, navOverlay } = props;
    return (
        <div className={navOverlay ? "topNavOverlay overlayVisible" : "topNavOverlay"} onClick={closeOverlay}></div>
    )
}
export default NavOverlay;